export default __webpack_public_path__ + "static/media/halloween-1-badge.1d074587.png";